/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
}

window.theme = window.theme || {};

Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number/100.0).toFixed(precision);

        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
}

//   const filterToggle = document.querySelector(".filter-toggle");
//   const filtersPanel = document.getElementById("filters-panel");
// const parentClassPanel = document.querySelector('.grid-area--filtering')

// function bindFilterEvents() {
//   const priceRangeEls = document.querySelectorAll(".price-range");
//   const params     = new URLSearchParams(window.location.search);
//   const gteParam   = params.get("filter.v.price.gte");
//   const lteParam   = params.get("filter.v.price.lte");
  
//   priceRangeEls.forEach(container => {
//     const formEl = container.closest('form');
//     const inputMinEl = container.querySelector('input[name="filter.v.price.gte"]');
//     const inputMaxEl = container.querySelector('input[name="filter.v.price.lte"]');
//     const displayMinEl = container.querySelector('.price-range__display-min');
//     const displayMaxEl = container.querySelector('.price-range__display-max');
//     const minRangeEl = container.querySelector('#min-price');
//     const maxRangeEl = container.querySelector('#max-price');

//     const formatPrice = (value) => {
//       return Shopify.formatMoney(value, "{{ amount }}");
//     };

//     const updateDisplays = () => {
//       displayMinEl.innerHTML = Shopify.formatMoney(minRangeEl.value, window.money_format);
//       displayMaxEl.innerHTML = Shopify.formatMoney(maxRangeEl.value, window.money_format);
//       inputMinEl.value = formatPrice(minRangeEl.value);
//       inputMaxEl.value = formatPrice(maxRangeEl.value);
//     };

//     updateDisplays();

//     minRangeEl.addEventListener("input", () => {
//       let val = minRangeEl.value;
//       if (parseFloat(val) > parseFloat(maxRangeEl.value)) {
//         minRangeEl.value = maxRangeEl.value;
//       }
//       updateDisplays();
//     });

//     maxRangeEl.addEventListener("input", () => {
//       let vals = maxRangeEl.value;
//       if (parseFloat(vals) < parseFloat(minRangeEl.value)) {
//         maxRangeEl.value = minRangeEl.value;
//       }
//       updateDisplays();
//     });

//     formEl.addEventListener("submit", (e) => {
//       e.preventDefault();
//       const formData = new FormData(formEl);
//       console.log('Filters applied:', [...formData.entries()]);
//     });
//   });

//   // Move apply-filters button event listener here
//   const applyFiltersBtn = document.querySelector(".apply-filters");
//   if (applyFiltersBtn) {
//     applyFiltersBtn.addEventListener("click", function (e) {
//       e.preventDefault();

//       const form = document.getElementById("CollectionFiltersForm");
//       const formData = new FormData(form);
//       const params = new URLSearchParams();

//       for (const pair of formData.entries()) {
//         params.append(pair[0], pair[1]);
//       }
//       let CollectionProductGrid = document.getElementById("CollectionProductGrid");
//       let sectionId = CollectionProductGrid.getAttribute("data-section-id");
      
//       const url = `${window.location.pathname}?section_id=${sectionId}&${params.toString()}`;

//       fetch(url)
//         .then(response => {
//           if (!response.ok) throw new Error("Section fetch failed");
//           return response.text();
//         })
//         .then(responseText => {
//           // Parse response HTML string
//           document.body.classList.remove("filters-open");
//           filtersPanel.style.display = "none";
//           const parser = new DOMParser();
//           const doc = parser.parseFromString(responseText, 'text/html');
        
//           // Grab the updated product grid section from parsed HTML
//           const newGridContent = doc.getElementById('CollectionProductGrid');
//           const currentGrid = document.getElementById('CollectionProductGrid');
        
//           if (newGridContent && currentGrid) {
//             // Replace current product grid content with new content
//             currentGrid.innerHTML = newGridContent.innerHTML;
            
//             // window.scrollTo({
//             //   top: currentGrid.offsetTop,
//             //   behavior: "smooth"
//             // });
//           }
//           bindFilterEvents();
//           const sectionEl = document.getElementById('CollectionProductGrid');
//           const productCount = document.getElementById('productcounts');
        
//           if (sectionEl && productCount) {
//             const productLength = sectionEl.querySelectorAll('.grid__item').length;
//             productCount.innerHTML = productLength;
//           }
//         })
//         .catch(err => {
//           console.error("Error fetching section:", err);
//           window.location.href = `${window.location.pathname}?${params.toString()}`;
//         });
//     });
//   }
// }

// function bindFilterToggles() {

  
//   if (filterToggle) {
//     filterToggle.addEventListener("click", function () {

//     if (document.body.classList.contains("filters-open")) {
//     document.body.classList.remove("filters-open");
//     // filtersPanel.style.display = "none";
//     parentClassPanel.classList.remove("filter-open-box");
//   } else {
//     document.body.classList.add("filters-open");
//       parentClassPanel.classList.add("filter-open-box");
//     // filtersPanel.style.display = "block";
//   }
//   });
//   }
  
// }

// Initial bindings
// document.addEventListener("DOMContentLoaded", function () {
//   bindFilterEvents();
//   bindFilterToggles();
// });
// document.addEventListener("DOMContentLoaded", () => {
//   const form = document.getElementById("CollectionFiltersForm");
//   const checkboxes = form.querySelectorAll(".filter-checkbox");
//   const priceMinInput = document.getElementById("price-min");
//   const priceMaxInput = document.getElementById("price-max");
//   const activeFiltersContainer = document.getElementById("ActiveFilters");
//   const productGrid = document.getElementById("CollectionProductGrid");
//   const productCount = document.getElementById("ProductCount");

//   const defaultMin = priceMinInput.getAttribute("data-default");
//   const defaultMax = priceMaxInput.getAttribute("data-default");

//   // Event listeners
//   checkboxes.forEach(cb => cb.addEventListener("change", updateFilters));
//   priceMinInput.addEventListener("input", updateFilters);
//   priceMaxInput.addEventListener("input", updateFilters);

//   function updateFilters() {
//     debugger;
//     const formData = new FormData(form);
//     const params = new URLSearchParams(formData).toString();
//     const url = `${form.action}?${params}`;

//     fetch(url)
//       .then(response => response.text())
//       .then(html => {
//         const doc = new DOMParser().parseFromString(html, "text/html");
//         productGrid.innerHTML = doc.querySelector("#CollectionProductGrid").innerHTML;
//         const count = doc.querySelectorAll("#CollectionProductGrid .grid__item").length;
//         productCount.innerText = `${count} products found`;

//         updateActiveFilters();
//       });
//   }

//   function updateActiveFilters() {
//     activeFiltersContainer.innerHTML = "";
//     let hasActive = false;

//     // Active checkboxes
//     form.querySelectorAll(".filter-checkbox:checked").forEach(cb => {
//       hasActive = true;
//       const label = cb.dataset.label || cb.parentElement.innerText.trim();
//       const span = createFilterItem(label, () => {
//         cb.checked = false;
//         updateFilters();
//       });
//       activeFiltersContainer.appendChild(span);
//     });

//     // Active price range (only if changed from default)
//     const currentMin = priceMinInput.value;
//     const currentMax = priceMaxInput.value;

//     if (currentMin !== defaultMin || currentMax !== defaultMax) {
//       hasActive = true;
//       const label = `Price: ${currentMin || defaultMin} - ${currentMax || defaultMax}`;
//       const span = createFilterItem(label, () => {
//         priceMinInput.value = defaultMin;
//         priceMaxInput.value = defaultMax;
//         updateFilters();
//       });
//       activeFiltersContainer.appendChild(span);
//     }

//     // Clear All button
//     if (hasActive) {
//       const clearBtn = document.createElement("button");
//       clearBtn.type = "button";
//       clearBtn.id = "ClearFiltersBtn";
//       clearBtn.innerText = "Clear All";
//       clearBtn.addEventListener("click", () => {
//         form.reset();
//         priceMinInput.value = defaultMin;
//         priceMaxInput.value = defaultMax;
//         updateFilters();
//       });
//       activeFiltersContainer.appendChild(clearBtn);
//     }
//   }

//   function createFilterItem(label, onRemove) {
//     const span = document.createElement("span");
//     span.className = "active-filter-item";
//     span.innerHTML = `${label} <button type="button" class="remove-filter">×</button>`;
//     span.querySelector("button").addEventListener("click", onRemove);
//     return span;
//   }

//   // Initial setup
//   updateActiveFilters();
//   const initialCount = document.querySelectorAll("#CollectionProductGrid .grid__item").length;
//   productCount.innerText = `${initialCount} products found`;
// });

// document.addEventListener("DOMContentLoaded", function () {
// if (!document.querySelector('.header-language_currency')) return;
//     const header = document.querySelectorAll('[class*="section-header-"]')

document.addEventListener('DOMContentLoaded', function () {
  const headers = document.querySelectorAll('.header-language_currency');

  document.addEventListener('click', (event) => {
    const target = event.target;
    const header = target.closest('.header-language_currency');

    // If clicked inside header
    if (header) {
      const languageCurrency = header.querySelector('.top-language-currency');
      const dropdownCurrency = header.querySelector('.dropdown-currency');
      const dropdownLanguage = header.querySelector('.dropdown-language');

      // Toggle main dropdown
      if (target.matches('.icon-languageCurrency') || target.closest('.icon-languageCurrency')) {
        languageCurrency?.classList.toggle('show');
      } else if (
        (target.matches('.top-language-currency') || target.closest('.top-language-currency')) &&
        !document.querySelector('.icon-languageCurrency')
      ) {
        languageCurrency?.classList.toggle('show');
      }

      // Toggle currency
      if (target.matches('.halo-top-currency') || target.closest('.halo-top-currency')) {
        dropdownLanguage?.classList.remove('show');
        dropdownCurrency?.classList.toggle('show');
      }

      // Toggle language
      if (target.matches('.halo-top-language') || target.closest('.halo-top-language')) {
        dropdownCurrency?.classList.remove('show');
        dropdownLanguage?.classList.toggle('show');
      }

      // When clicking on a currency item
      if (target.matches('.dropdown-item[data-currency]') || target.closest('.dropdown-item[data-currency]')) {
        dropdownCurrency?.classList.remove('show');
        languageCurrency?.classList.remove('show');
      }

      // When clicking any dropdown item (language/currency)
      if (target.matches('.dropdown-menu .dropdown-item')) {
        dropdownCurrency?.classList.remove('show');
        dropdownLanguage?.classList.remove('show');
        languageCurrency?.classList.remove('show');
      }
    } else {
      // Clicked outside — close all
      headers.forEach((el) => {
        el.querySelector('.top-language-currency')?.classList.remove('show');
        el.querySelector('.dropdown-currency')?.classList.remove('show');
        el.querySelector('.dropdown-language')?.classList.remove('show');
      });
    }
  });
});
    

// })